import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const inspectModeIcon = createIconDefinition(
  'inspectModeIcon',
  `<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1378_207141)">
<path d="M10 11.6667C10.9205 11.6667 11.6667 10.9205 11.6667 10C11.6667 9.07952 10.9205 8.33333 10 8.33333C9.07952 8.33333 8.33333 9.07952 8.33333 10C8.33333 10.9205 9.07952 11.6667 10 11.6667Z"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.8333 2.55C14.3083 2.93333 17.0667 5.69167 17.45 9.16667H19.1667V10.8333H17.45C17.0667 14.3083 14.3083 17.0667 10.8333 17.45V19.1667H9.16667V17.45C5.69167 17.0667 2.93333 14.3083 2.55 10.8333H0.833333V9.16667H2.55C2.93333 5.69167 5.69167 2.93333 9.16667 2.55V0.833333H10.8333V2.55ZM4.16667 10C4.16667 13.225 6.775 15.8333 10 15.8333C13.225 15.8333 15.8333 13.225 15.8333 10C15.8333 6.775 13.225 4.16667 10 4.16667C6.775 4.16667 4.16667 6.775 4.16667 10Z"/>
</g>
<defs>
<clipPath id="clip0_1378_207141">
<rect width="20" height="20"/>
</clipPath>
</defs>
</svg>
`,
);
